(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Kaiju-Spotted"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.klaviyo-alert-link').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        if (window._klOnsite) {
          window._klOnsite.push(['openForm', 'USmQxF']);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Pre-Order-Status-Dynamic"] && !Shopify.designMode) return;
  try {
    
  // Offset scroll by 120px for site navigation
  document.querySelectorAll('.alphabet-link').forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      var targetId = this.getAttribute('href').substring(1);
      var targetElement = document.getElementById(targetId);
      var offset = 160; // Adjust the offset as needed
      var elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d20-roll"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const die = document.querySelector('.die');
  const sides = 20;
  const slideshowItems = document.querySelectorAll('.roller-wrapper ul li');
  const placeholder = document.querySelector('.placeholder');
  const prevArrow = document.querySelector('.nav-arrow.prev');
  const nextArrow = document.querySelector('.nav-arrow.next');
  const slideshow = document.querySelector('.roller-wrapper ul');
  const animationDuration = 3000;
  const fadeDuration = 1500;
  let activeSlideIndex = 0;
  let isRolling = false; 

  // Function to set initial state
  function setInitialState() {
    slideshowItems.forEach(item => item.classList.remove('active'));
    slideshowItems[0].classList.add('active');
    placeholder.classList.add('active');
    slideshow.style.display = 'none'; // Hide slideshow initially

    die.setAttribute('data-face', '1');
    if (prevArrow) {
      prevArrow.style.display = 'none'; 
      prevArrow.style.opacity = 0; 
    }
    if (nextArrow) {
      nextArrow.style.opacity = 1;
      nextArrow.style.display = "block"; 
    }
  }

  setInitialState();

  // Event listener for clicking on the die
  die.addEventListener('click', function (event) {
    event.preventDefault();
    if (isRolling) return;
    isRolling = true;

    placeholder.classList.remove('active');
    rollTo(randomFace());

    // Track the dice click event in Google Analytics
    gtag('event', 'click', {
      'event_category': 'Dice Roll',
      'event_label': 'Dice' 
    });
  });


  // Event listeners for clicking on slideshow items
  slideshowItems.forEach((item, index) => {
    item.addEventListener('click', function (event) { 
      event.preventDefault();
      if (isRolling) return;
      isRolling = true;

      placeholder.classList.remove('active');
      rollTo(randomFace()); 
    });
  });

  // Event listener for clicking on previous arrow
  if (prevArrow) {
    prevArrow.addEventListener('click', function (event) {
      event.preventDefault();
      const previousFace = (activeSlideIndex > 0) ? activeSlideIndex : slideshowItems.length;
      rollTo(previousFace);
    });
  }

  // Event listener for clicking on next arrow
  if (nextArrow) {
    nextArrow.addEventListener('click', function (event) {
      event.preventDefault();
      const nextFace = (activeSlideIndex + 2 <= slideshowItems.length) ? activeSlideIndex + 2 : 1;
      rollTo(nextFace);
    });
  }

  // Function to handle both random and manual rolls
  function rollTo(face) {
    if (face === null || isNaN(face) || face < 1 || face > sides) {
      return;
    }

    die.classList.add('rolling');
    isRolling = true;

    // Start fading out placeholder and hiding arrows
    if (placeholder) {
      placeholder.style.transition = `opacity ${fadeDuration}ms ease`;
      placeholder.style.opacity = 0;
    }
    slideshowItems[0].style.display = 'none'; // Hide the initial slide

    if (prevArrow) {
      prevArrow.style.transition = `opacity ${fadeDuration}ms ease`;
      prevArrow.style.opacity = 0;
    }
    if (nextArrow) {
      nextArrow.style.transition = `opacity ${fadeDuration}ms ease`;
      nextArrow.style.opacity = 0;
    }
  
    setTimeout(function () {
      die.setAttribute('data-face', face.toString());
      
      slideshow.style.display = 'block'; // Show the slideshow container

      slideshowItems[activeSlideIndex].style.transition = `opacity ${fadeDuration}ms ease`;
      slideshowItems[activeSlideIndex].style.opacity = 0;

      setTimeout(function () {
        slideshowItems.forEach((item, index) => {
          item.style.display = index === face - 1 ? 'block' : 'none';
          item.style.opacity = 0; // Make the new slide initially invisible
          item.style.transition = 'none';
        });

        activeSlideIndex = face - 1;

        // Update arrow visibility
        if (prevArrow) {
          prevArrow.style.display = activeSlideIndex === 0 ? 'none' : 'block';
          prevArrow.style.opacity = activeSlideIndex === 0 ? 0 : 1;
        }
        if (nextArrow) {
          nextArrow.style.display = activeSlideIndex === slideshowItems.length - 1 ? 'none' : 'block';
          nextArrow.style.opacity = activeSlideIndex === slideshowItems.length - 1 ? 0 : 1;
        }

        setTimeout(() => {
          slideshowItems[activeSlideIndex].style.transition = `opacity ${fadeDuration}ms ease`;
          slideshowItems[activeSlideIndex].style.opacity = 1;
          if (prevArrow && activeSlideIndex !== 0) {
            prevArrow.style.transition = `opacity ${fadeDuration}ms ease`;
            prevArrow.style.opacity = 1;
          }
          if (nextArrow && activeSlideIndex !== slideshowItems.length - 1) {
            nextArrow.style.transition = `opacity ${fadeDuration}ms ease`;
            nextArrow.style.opacity = 1;
          }
        }, 10);
      }, fadeDuration); // Delay to ensure fade-out completes before fade-in

      // Hide placeholder after fade-out (if placeholder exists)
      if (placeholder) {
        setTimeout(() => {
          placeholder.style.display = 'none';
        }, fadeDuration);
      }

      setTimeout(() => {
        die.classList.remove('rolling');
        isRolling = false;
      }, animationDuration);
    }, fadeDuration); // Wait for placeholder to fully fade out
  }

  // Function to get a random face
  function randomFace() {
    return Math.floor(Math.random() * sides) + 1;
  }

  // Function to handle randomize button click (if exists)
  function randomizeClickHandler() {
    if (isRolling) return; 
    isRolling = true; 

    placeholder.classList.remove('active');
    rollTo(randomFace());
  }

  // Add event listener to the randomize button (if it exists)
  var randomizeButton = document.getElementById('randomizeButton');
  if (randomizeButton) {
    randomizeButton.removeEventListener('click', randomizeClickHandler);
    randomizeButton.addEventListener('click', randomizeClickHandler);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preorder-items"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.alphabet-link').forEach(link => {
  link.addEventListener('click', function(e) {
    e.preventDefault();
    const target = document.getElementById(this.getAttribute('href').substring(1));
    const offset = 180;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: top, behavior: 'smooth' });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safety-pop-up"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const mainDude = document.querySelector('.main-character');

    if (mainDude) {
      mainDude.style.cursor = 'pointer'; // Optional: show pointer on hover
      mainDude.addEventListener('click', function () {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'QYSQvW']);
      });
    }
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdcc-24-slides"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {
    const cards = document.querySelectorAll('.sdcc-card');
    const grid = document.querySelector('.sdcc-grid');
    let activeCard = null;
    let activeSlideshow = null;

    const slideshows = {
        slideshow1: [
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/ST-CreatureFromTheBlackLagoon_BoxFigure_SDCC-Graphic-1200comp.jpg?v=1719352157', caption: 'Super Cycles - Creature from the Black Lagoon' },
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/ST-CharlieBrown_BoxFigure_SDCC-Graphic-1200comp.jpg?v=1719354366', caption: 'Super Cycles - Charlie Brown (Peanuts Exclusive)' }
        ],
        slideshow2: [
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/RE-Worst_W5_5up_Card_SDCC-Graphic-1200comp.jpg?v=1719436296', caption: 'The Villaneous Worst ReAction Figures' },
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/RE-HalloweenKids_Snoopy_Card_SDCC-Graphic-1200comp.jpg?v=1719436403', caption: 'Peanuts Halloween Kids - Snoopy' },
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/RE-HalloweenKids_MummyBoy_S7GraphicTee_Card_SDCC-Graphic-1200comp.jpg?v=1719436403', caption: 'Super7 Halloween Kids - Mummy Boy' },
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/VY-Super7_MummyBoyTokyo_Grid_Front_SDCC-Graphic-1200comp.jpg?v=1719436296', caption: 'Japanese Vinyl - Mummy Boy' },
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/VY-Super7_OozeBatGrape_Grid_SDCC_Graphic-1200comp.jpg?v=1719436296', caption: 'Japanese Vinyl - Ooze Bat' }, 
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/AC-Super7_JapanJersey-Crew2024_Tee_SDCC-Graphic-1200comp.jpg?v=1719436296', caption: 'Super7 Japan Jersey Shirt' },          
        ],
        slideshow3: [
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/RE-TOHO_JetJaguar-Godzilla_Box_Front_SDCC-Graphic-1200comp.jpg?v=1719504797', caption: 'Godzilla & Jet Jaguar 2-Pack' },
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/RE-Toho_HedorahVintageHawaii_Card_SDCC-Graphic-1200comp_1.jpg?v=1719505169', caption: 'Toho ReAction Hedorah (Vintage Toy Hawaii)' },
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/AC-TOHO_Hedorah-Smokestack_Tee_SDCC-Graphic-1200comp.jpg?v=1719504797', caption: 'Toho Hedorah Smokestack Tee' },
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/RE-TOHO_2upGlow_Card_SDCC-Graphic-1200comp.jpg?v=1719504798', caption: 'Toho ReAction Anguirus & Baragon Glow' },
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/RE-TOHO_GodzillaModelKit_BoxFigure_SDCC-Graphic-1200comp.jpg?v=1719504797', caption: 'Godzilla ReAction Figure (Vintage Model Kit)' }, 
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/UL-Toho_ShogunGodzilla_VintageRed_Box_SDCC-Graphic-1200comp.jpg?v=1719504797', caption: 'Shogun Godzilla ULTIMATES! Figure (Vintage Red)' }        
        ],
        slideshow4: [
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/RE-THKR_ThrillaGorilla_Card_SDCC-Graphic-1200comp.jpg?v=1719529589', caption: 'Thrilla Krew ReAction - Thrilla Gorilla' }    
        ],
        slideshow5: [
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/RE-GIJOE_SnakeEyes-ComicV3_Card_SDCC-Graphic-1200comp.jpg?v=1719595771', caption: 'G.I. Joe ReAction Figures - Snake Eyes (Comic)' },    
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/UL-GIJoe_CobraMortal_Box_Open_SDCC-Graphic-1200comp.jpg?v=1719595771', caption: 'G.I. Joe ULTIMATES! - Cobra Mortal' },    
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/UL-GIJoe_ZartanJungleTrap_Box_Open_SDCC-Graphic-1200comp.jpg?v=1719595771', caption: 'G.I. Joe ULTIMATES! - Zartan (Jungle Trap)' },    
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/V-Conan_W1_ConanBloodSplatter_Card_SDCC-Graphic-1200comp.jpg?v=1719595921', caption: 'Conan the Barbarian Vintage - Conan (Blood Splatter)' }
        ],
        slideshow6: [
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/RE-Willy_Wonka_Wonka_In_Box_Hero-1_SDCC-1200comp.jpg?v=1719597007', caption: 'Willy Wonka™ - Wonka Bar ReAction Blind Box' },
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/RE-WillyWonka_WillyWonka-Gold_Box-Grid_SDCC-Graphic-1200comp.jpg?v=1719597007', caption: 'Golden Willy Wonka™ Chase (Limited to 200)' },
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/RE-WillyWonka_WillyWonka_Box-Grid_SDCC-Graphic-1200comp.jpg?v=1719597078', caption: 'Chocolate Brown Willy Wonka™ ReAction' }
        ],
        slideshow7: [
         { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/AC-Peanuts_Charlie_Brown_Wax-Pack_Group_SDCC_Graphic-1200comp.jpg?v=1720719975', caption: 'Peanuts Wax Packs (Peanuts Exclusive)' },   
          { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/AC-Peanuts_PeppermintPatty-Tee_SDCC-Graphic-1200comp.jpg?v=1720719975', caption: 'Peanuts Peppermint Patty T-Shirt' },
          { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/AC-Peanuts_Woodstock-Skate_Tee_SDCC_Graphic-1200comp_1.jpg?v=1720719975', caption: 'Peanuts Woodstock T-Shirt' },
          { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/AC-Richard-Scarry-Lowly-Worm-Tee-1200comp.jpg?v=1720719975', caption: 'Richard Scarry Lowly Worm T-Shirt' }, 
          { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/AC-SesameStreet_SuperGrover_Tee_SDCC-Graphic-1200comp.jpg?v=1720719975', caption: 'Sesame Street Super Grover T-Shirt' }
        ],
        slideshow8: [
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/RE-ROTLD_W3_2up-BlacklightGlow_Card_SDCC-Graphic-1200comp.jpg?v=1721071037', caption: 'Return of the Living Dead Flocked Blackight ReAction' },
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/AC-MarsAttacks_Wax_Wrapper-Tee_Graphic-SDCC-1200comp.jpg?v=1721071028', caption: 'Mars Attacks Glow in the Dark T-Shirt' }
        ],
        slideshow9: [

            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/AC-MMPR_SDCC_Megazord-Pixel_Tee_SDCC-Graphic-1200comp.jpg?v=1721073342', caption: 'Mighty Morphin Power Rangers Pixel Megazord T-Shirt' },
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/UL-MMPR_GlowLordZedd_Box_Graphic-SDCC-1200comp.jpg?v=1721073431', caption: 'Mighty Morphin Power Rangers Lord Zedd Glow' },
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/AC-Jem_and_the_Holograms_World_Tour_Tee_Stacked_SDCC_Graphic-1200comp.jpg?v=1721072040', caption: 'Jem and the Holograms World Tour T-Shirt' },
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/AC-GPK_JapaneseGPK_Tee_Stacked_SDCC-Graphic-1200comp.jpg?v=1721073780', caption: 'GPK - Adam Bomb Japanese T-Shirt' }            
        ],  
        slideshow10: [
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/RE-Voltron_VintageBox_BoxFigure_SDCC-Graphic-1200comp.jpg?v=1721234808', caption: 'Voltron ReAction Retro' },
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/RE-Transformers_2up-G1_Box_SDCC-Graphic-1200comp.jpg?v=1721073476', caption: 'Transformers ReAction - Unicron and Grimlock' },
            { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/AC-Transformers_BlasterCassette-Tee_SDCC-Graphic-1200comp.jpg?v=1721073463', caption: 'Transformers Blaster T-Shirt' }
        ],  
        slideshow11: [
          { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/UL-Thundercats_GhostGrune_Box_SDCC-Graphic-1200comp_1.jpg?v=1721322128', caption: 'ThunderCats ULTIMATES! Ghost Grune' },
         { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/UL-ThunderCats_LED_Eyes_Group_Hero-1200comp_1.jpg?v=1721322128', caption: 'ThunderCats ULTIMATES! Light Up LED Eyes' }, 
          { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/UL-Thundercats_LED_Mumm-Ra_Grid_SDCC_Graphic-1200comp.jpg?v=1721322128', caption: 'ThunderCats ULTIMATES! Light Up LED Eyes' }, 
          { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/UL-Thundercats_LED_LionO_Grid_SDCC_Graphic-1200comp.jpg?v=1721322128', caption: 'ThunderCats ULTIMATES! Light Up LED Eyes' },
          { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/UL-Thundercats_LED_Mumm-Ra_Box_Closed_SDCC_Graphic-1200comp_1.jpg?v=1721322127', caption: 'ThunderCats ULTIMATES! Light Up LED Eyes' }, 
          { url: 'https://cdn.shopify.com/s/files/1/2726/1450/files/UL-Thundercats_LED_LionO_Box_Closed_SDCC_Graphic-1200comp_1.jpg?v=1721322128', caption: 'ThunderCats ULTIMATES! Light Up LED Eyes' }         
        ],  
    };

    const shuffledCards = Array.from(cards).sort(() => 0.5 - Math.random());

    shuffledCards.forEach((card, index) => {
        const slideshowId = card.dataset.slideshowId;
        if (!slideshows[slideshowId]) {
            card.classList.add('desaturated');
        } else {
            card.addEventListener('click', () => {
                if (activeCard && activeCard === card) {
                    flipCard(activeCard);
                    gsap.to(activeSlideshow, { opacity: 0, duration: 0.2, onComplete: () => {
                        activeSlideshow.remove();
                        activeSlideshow = null;
                        activeCard = null;
                    }});
                    return;
                }

                if (activeCard) {
                    flipCard(activeCard);
                    gsap.to(activeSlideshow, { opacity: 0, duration: 0.2, onComplete: () => {
                        activeSlideshow.remove();
                        activeSlideshow = null;
                        activateNewCard(card);
                    }});
                } else {
                    activateNewCard(card);
                }
            });
        }

        const finalOpacity = card.classList.contains('desaturated') ? 0.95 : 1;
        gsap.fromTo(card, { opacity: 0 }, { opacity: finalOpacity, delay: index * 0.25, duration: 0.5 });
    });

    function activateNewCard(card) {
        const slideshowId = card.dataset.slideshowId;
        const slideshowTemplate = document.getElementById('slideshow-template').cloneNode(true);
        slideshowTemplate.style.display = 'block';
        slideshowTemplate.style.margin = '0px';
        slideshowTemplate.id = '';

        const cardIndex = Array.from(cards).indexOf(card);
        const rowIndex = Math.floor(cardIndex / getColumnsCount());
        const rowPosition = (rowIndex + 1) * getColumnsCount();
        const insertBeforeNode = grid.children[rowPosition] || null;
        grid.insertBefore(slideshowTemplate, insertBeforeNode);
        activeSlideshow = slideshowTemplate;
        initializeSlideshow(slideshowTemplate, slideshows[slideshowId]);
        animateSlideshow(slideshowTemplate);
        flipCard(card);
        if (window.innerWidth >= 768) {
            fireStars(card);
        }
        activeCard = card;
    }

    function getColumnsCount() {
        return window.innerWidth <= 740 ? 2 : 3;
    }

    function flipCard(card) {
        card.classList.toggle('flipped');
    }

    function initializeSlideshow(slideshowTemplate, slides) {
        const swiperWrapper = slideshowTemplate.querySelector('.swiper-wrapper');
        swiperWrapper.innerHTML = '';

        slides.forEach(slideData => {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide';
            const img = document.createElement('img');
            img.src = slideData.url;
            const caption = document.createElement('div');
            caption.className = 'slide-caption';
            caption.textContent = slideData.caption;
            slide.appendChild(img);
            slide.appendChild(caption);
            swiperWrapper.appendChild(slide);
        });

        new Swiper(swiperWrapper.parentNode, {
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        });
    }

    function animateSlideshow(slideshowTemplate) {
        gsap.fromTo(slideshowTemplate, { opacity: 0 }, { opacity: 1, duration: 0.5 });
    }

    function fireStars(card) {
        const count = 30;
        const colors = ['#fcfae1', '#d43f20', '#273371'];
        const rect = card.getBoundingClientRect();
        const cardInner = card.querySelector('.sdcc-card-inner'); // Get the inner card element
        const innerRect = cardInner.getBoundingClientRect(); // Get the position of the inner card
        const starsContainer = document.createElement('div');

        // Use the position of the inner card instead
        starsContainer.style.position = 'absolute';
        starsContainer.style.left = `${innerRect.left + window.scrollX}px`;
        starsContainer.style.top = `${innerRect.top + window.scrollY}px`;
        starsContainer.style.width = `${innerRect.width}px`;
        starsContainer.style.height = `${innerRect.height}px`;
        starsContainer.style.pointerEvents = 'none';
        document.body.appendChild(starsContainer);

        for (let i = 0; i < count; i++) {
            const star = document.createElement('div');
            star.classList.add('gStar');
            star.innerHTML = '<i class="fas fa-star"></i>';
            starsContainer.appendChild(star);

            const angle = Math.random() * 360;
            const dist = Math.random() * 100;
            const sz = Math.random() * 42 + 18; // Increased size
            const starSpeed = 0.3 + Math.random() * 0.3;

            gsap.set(star, { fontSize: sz, xPercent: -50, yPercent: -50, left: `${Math.random() * 100}%`, top: `${Math.random() * 100}%`, rotation: Math.random() * 360 });
            gsap.set(star, { color: colors[Math.floor(Math.random() * colors.length)], x: -sz / 2, y: -sz / 2, opacity: 1, scale: 0, zIndex: 500, rotation: Math.floor(Math.random() * 360) });
            gsap.to(star, { scale: 1.25, duration: 0.15 });
            gsap.to(star, { autoAlpha: 0.7, duration: 0.35 });
            gsap.to(star, {
                x: Math.cos(angle * Math.PI / -180) * dist,
                y: Math.sin(angle * Math.PI / -180) * dist,
                rotation: 280, scale: 1,
                ease: "none",
                duration: Math.floor(Math.random() * (starSpeed * 100) + (starSpeed * 100 / 3)) / 100
            });
            gsap.to(star, {
                autoAlpha: 0, duration: 0.65, delay: Math.floor(Math.random() * (starSpeed * 100) + (starSpeed * 100 / 3)) / 100 - 0.25,
                onComplete: () => star.remove()
            });
        }

        setTimeout(() => {
            starsContainer.remove();
        }, 1000);
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toho-foil-1-chase"] && !Shopify.designMode) return;
  try {
    
  function addShimmerEffect() {
    const images = document.querySelectorAll('.shimmer-wrapper');
    images.forEach(img => img.classList.remove('shimmer-active'));
    
    const randomIndex = Math.floor(Math.random() * images.length);
    images[randomIndex].classList.add('shimmer-active');
  }

  setInterval(addShimmerEffect, 3000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toho-popup-slideshow-2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const slides = document.querySelectorAll('.warning-slider-image');
  const staticOverlay = document.querySelector('.warning-slider-static');
  const prevBtn = document.querySelector('.warning-slider-arrow.prev');
  const nextBtn = document.querySelector('.warning-slider-arrow.next');
  let current = 0;
  let interval;

  function showImage(index) {
    staticOverlay.style.opacity = 1;
    slides[current].style.opacity = 0;

    setTimeout(() => {
      slides[index].style.opacity = 1;
      setTimeout(() => {
        staticOverlay.style.opacity = 0;
        current = index;
      }, 600);
    }, 300);
  }

  function showNextImage() {
    const next = (current + 1) % slides.length;
    showImage(next);
  }

  function showPrevImage() {
    const prev = (current - 1 + slides.length) % slides.length;
    showImage(prev);
  }

  if (slides.length > 0) {
    slides[0].style.opacity = 1;
    interval = setInterval(showNextImage, 3000);
  }

  nextBtn.addEventListener('click', () => {
    clearInterval(interval);
    showNextImage();
  });

  prevBtn.addEventListener('click', () => {
    clearInterval(interval);
    showPrevImage();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toho-popup-slideshow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const slides = document.querySelectorAll('.warning-slider-image');
  const staticOverlay = document.querySelector('.warning-slider-static');
  let current = 0;

  function showNextImage() {
    const next = (current + 1) % slides.length;

    // Show static first
    staticOverlay.style.opacity = 1;

    // Fade out current image
    slides[current].style.opacity = 0;

    // Wait for static to show, then switch image
    setTimeout(() => {
      slides[next].style.opacity = 1;

      // After brief pause, hide static
      setTimeout(() => {
        staticOverlay.style.opacity = 0;
        current = next;
      }, 600); // keep static on top for a bit
    }, 300);
  }

  if (slides.length > 0) {
    slides[0].style.opacity = 1;
    setInterval(showNextImage, 3000);
  }
});
  
  } catch(e) { console.error(e); }
})();
})();
